module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-chart-radar"
    }
  }, [_c('radar-example')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e428dd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoChartRadar.vue
// module id = 3848
// module chunks = 1